import styled from 'styled-components';
import Colors from 'assets/Colors.js';
import Constants from 'helpers/constants';

const BodyContainer = styled.div`
max-width: 1057px;
  margin: auto;
  margin-top: 38px;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 49px;
   display: flex;
   flex-direction: column;
  @media (max-width: ${Constants.pxMobileBreakPoint}px) {
    flex-direction: column;
  }
`;

const SectionTitle = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.01em;
  line-height: 18px;
`;

const addComponent = styled.a`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 22px;
  text-decoration: underline;
  color: ${Colors.text_primary};
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: ${Colors.text_primary};
`;

const SubTitle = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 22px;
  color: ${Colors.text_primary};
`;

const Line = styled.div`
  height: 1px;
  width: 100%;
  background: ${Colors.background_dividers};
`;

const Dividir = styled.div`
  height: 0.5px;
  margin-bottom: 10px;
  width: 100%;
  background: ${Colors.divider};
  :last-child {
    display: none;
  }
`;

const TitleAndButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`;

const ColorWrapper = styled.div`
  border-radius: 5px;
  margin-bottom: 16px;
  display: grid;
  align-items: center;
  width: 211px;
  height: 116.29px;
  place-content: center;

  ${(props) =>
    (props.color
      ? `background: ${props.color};`
      : `border: 1px solid ${Colors.background_dividers};`)}
`;

const LeftContainer = styled.div`
  max-width: 583px;
  margin-right: 84px;
  flex-grow: 1;
  @media (max-width: ${Constants.pxMobileBreakPoint}px) {
    margin-right: 0px;
    max-width: unset;
  }
`;

const RightContainer = styled.div`
  @media (max-width: ${Constants.pxMobileBreakPoint}px) {
    display: none;
  }
`;

const RightContainerOnBottom = styled.div`
  @media (min-width: ${Constants.pxMobileBreakPointNext}px) {
    display: none;
  }
`;

const messageAlert = styled.p`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.notification_failed};
`;

const TableCell = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export default {
  BodyContainer,
  Title,
  SubTitle,
  Line,
  Dividir,
  TitleAndButtonContainer,
  ColorWrapper,
  LeftContainer,
  RightContainer,
  RightContainerOnBottom,
  SectionTitle,
  addComponent,
  TableCell,
  messageAlert
};
